const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100vh",
        padding: "2vw",
        boxSizing: "border-box",
        overflowY: "auto"
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "2vw"
    },
    title: {
        fontSize: "1.8vw",
        fontWeight: 700,
        color: (theme) => theme.palette.text.primary
    },
    tableContainer: {
        width: "100%",
        backgroundColor: "#fff",
        borderRadius: "8px",
        padding: "1vw",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
    },
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "400px"
    },
    dataGrid: {
        border: 'none',
        '& .MuiDataGrid-cell': {
            borderBottom: '1px solid #f0f0f0',
        },
        '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#f5f5f5',
            borderBottom: '2px solid #e0e0e0',
        }
    }
}

export default styles;

